<template>
  <div class="distributionOrder">
 <el-dialog
    :visible.sync="dialogVisible"
    :title='$t('other.a373')'
    width="70%"
    >
 
     <template>
       
      </template>
      <span slot="footer" class="dialog-footer">
        
        <el-button type="primary" @click="dialogVisible = false">{{$t('other.a5')}}</el-button>
      </span>
    </el-dialog>

      <div class="header_warpper">
          <div class="left">
              <!-- <div class="logo"></div> -->
              <div class="title">{{$t('other.a374')}}</div>
              <div>{{$t('other.a375')}}</div>
          </div>
          <div class="right">
              <div class="shopifylogo"></div>
          </div>
      </div>
      <div class="center">
          <div class="desc_title">
              <div>
                  <div>{{$t('other.a376')}}</div>
                  <div>{{$t('other.a376')}}</div>
              </div>
              <div>
                <div>{{$t('other.a377')}}</div>
              </div>
          </div>
          <div class="ttp">
              <div>{{$t('other.a378')}}</div>
              <div>{{$t('other.a379')}}</div>
              <div>{{$t('other.a380')}}</div>
              <div>{{$t('other.a381')}}</div>
              <div>{{$t('other.a77')}}</div>
              <div>{{$t('other.a33')}}</div>
          </div>

          <div >
              <div class="itemList" v-for="(item,index) in distributionOrder" :key="index">
                 <div class="picbox"><img :src="item.image"></div>
                 <div>{{item.groupName}}</div>
              </div>
             
          </div>

      </div>
  </div>
</template>

<script>
import api from '../../src/api/moudles/shopaccess'
import { mapState, mapActions, mapMutations } from "vuex";
export default {
data(){
return{
    hasAccess:false,
    test:null,
}
},
computed:{
    
    ...mapState({
        userId: (state) => state.shopaccess.userInfo.userId,
        userName: (state) => state.shopaccess.userInfo.userName,
        distributionOrder:(state) => state.common.distributionOrder,
    }),
},
created(){
    this.init()
},
methods:{

    
    
    init(){
        console.log(this.distributionOrder)
        let url=location.href
        if(url.indexOf('?') > -1){
            let num=url.indexOf('?')
            let ttp=url.slice(num+1)
            console.log(ttp)
            let list=ttp.split('&')
            console.log(list)
            let params={
                code:list[0].slice(5),
                force:true,
                shop:list[3].slice(5).split('.')[0],
                userId:JSON.parse(localStorage.getItem('userInfo')).userId
            }

            api
            .bindShopify(params)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.hasAccess=true
             this.$message.success(this.$t('other.a382'))
            }else{
                this.hasAccess=false
                this.test=res.msg
            this.$message.warning(res.msg)
            }
            })

            console.log(params)
            

        }
        
    },
    goto(num){
        if(num == 0){
            this.$router.push('/index')
        }else if(num == 1){
             this.$router.push('/index')
        }else if(num == 2) {
            this.$router.push('/index')
        }else if(num == 3){
            this.$router.push('/index')
        }
    }

}
}

</script>
<style lang="scss" scoped>
.distributionOrder{
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;

    .center{
        margin: 0 auto;
        width: 1200px;
        min-height: 100vh;


        .itemList{
            display: flex;
        }

        .desc_title{
            display: flex;
            justify-content: space-between;
            padding: 20px 0 10px 0;
            border-bottom: 1px solid #eeee;
        }

        .picbox{
            width:80px;
            height: 80px;
            overflow: hidden;

            img{
                width: 100%;
            }
        }

        .ttp{
            display: flex;
            justify-content: space-between;


        }
    }
    

    .header_warpper{
        margin: 0 auto;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        padding-bottom: 16px;
        border-bottom: 1px solid #606266;
       


        .left{
            display: flex;
            align-items: center;
            padding-top: 30px;
          

            .title{
                font-size: 25px;
                font-weight: bold;
                  color: #409eff;
            }

            .title::after{
                content:'|';
                color:#606266;
                padding:0 10px
            }

            .logo{
                width: 30px;
                height: 15px;
                
                background-size: 100%;
                background-repeat: no-repeat;;
                background-image: url('../assets/img/h5_login.png');
            }
        }


        .right{
            display: flex;
            
            align-items: center;

            .desxc{
                line-height: 75px;
                height: 50px;
                font-size: 20px;
                font-weight: bold;
            }
        }


        .shopifylogo{
            width: 55px;
            height: 44px;
            background-image: url('../assets/img/h5_login.png');
            background-size: 100%;
            background-repeat: no-repeat;;
        }

    }
}
</style>